export const TRANSCRIPT_CONTENT_PADDING = "px-4 md:px-[max(1.75rem,calc((100%_-_60rem)/2))]";
